/* eslint-disable no-param-reassign */
import { action, thunk, computed } from 'easy-peasy';
import { reject } from 'lodash/fp';
import { fetchReservationPicklsits } from '../../services/fbm-api';

export default {
  data: null,
  meta: null,
  error: null,
  loading: false,
  fetch: thunk(async (actions, payload) => {
    try {
      actions.setLoading(true);
      const response = await fetchReservationPicklsits(payload);
      actions.set(response);
    } catch (error) {
      actions.setError(error);
    } finally {
      actions.setLoading(false);
    }
  }),
  set: action((state, payload) => {
    const { items, meta } = payload;
    state.data = items;
    state.meta = meta;
  }),
  clear: action(state => {
    state.data = null;
    state.meta = null;
  }),
  setError: action((state, error) => {
    state.error = error;
  }),
  setLoading: action((state, loading) => {
    state.loading = loading;
  }),
  visiblePicklists: computed(({ data }) =>
    !data ? null : reject(({ isVisible = true }) => !isVisible, data)
  )
};
